import { ActionButton } from '@bugbug/core/components/Button';
import Icon from '@bugbug/core/components/Icon';
import styled from 'styled-components';

export const PlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;
  gap: 32px;
  border: 2px solid ${(props) => props.theme.colors.border.medium};
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  height: 100%;
`;

export const OuterWrapper = styled.div`
  padding: 2px;
  padding-bottom: 0;
  margin: -2px;
  margin-bottom: 0;
  position: relative;
  overflow: hidden;
`;

export const Badge = styled.div`
  position: absolute;
  top: 22px;
  right: -49px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 12px;
  line-height: 37px;
  color: ${(props) => props.theme.colors.common.white};
  font-weight: ${(props) => props.theme.fontWeight.bold};
  background-color: ${(props) => props.theme.colors.accent};
  transform: rotate(45deg);
  text-transform: uppercase;
  width: 180px;
`;

export const PlanTitle = styled.h3`
  font-size: 22px;
  height: 40px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.primary};
  font-weight: ${(props) => props.theme.fontWeight.bold};
  letter-spacing: 1px;
  margin: 0;
`;

export const PlanDescription = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.colors.text.secondary};
  line-height: 1.5;
  margin: 0;
`;

export const PlanPrice = styled.p`
  font-size: 46px;
  color: ${(props) => props.theme.colors.brand};
  font-weight: ${(props) => props.theme.fontWeight.medium};
  letter-spacing: -1px;
  margin: 0;
  line-height: 1;
  margin-bottom: 8px;
`;

export const FeaturesList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
`;

export const FeaturesTitle = styled.p`
  font-size: 16px;
  font-weight: ${(props) => props.theme.fontWeight.bold};
  margin: 0;
`;

export const FeaturesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 32px;
`;

export const MainFeaturesList = styled(FeaturesList)`
  gap: 10px;
`;

export const ManageSubscriptionButton = styled(ActionButton)`
  height: 50px;
  border-radius: 100px;
  font-size: 16px;
  width: 100%;

  span {
    margin-right: 0;
  }
`;

export const UpgradeIcon = styled(Icon).attrs(() => ({
  name: 'upgrade',
}))`
  width: 18px;
  height: 18px;
  margin-right: 6px;
`;

export const DowngradeIcon = styled(Icon).attrs(() => ({
  name: 'upgrade',
}))`
  width: 18px;
  height: 18px;
  transform: rotate(180deg);
  margin-right: 6px;
`;

export const CurrentPlan = styled.div`
  display: flex;
  height: 50px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  font-size: 16px;
  padding-bottom: 2px;
  font-weight: ${(props) => props.theme.fontWeight.bold};
  background-color: ${(props) => props.theme.colors.background.highlight};
  color: ${(props) => props.theme.colors.primary};
`;

export const CurrentPlanIcon = styled(Icon).attrs(() => ({
  name: 'checkCircle',
}))`
  width: 18px;
  height: 18px;
  margin-right: 6px;
  color: ${(props) => props.theme.colors.primary};
  transform: translateY(1px);
`;

export const PlanForm = styled.div`
  font-size: 16px;
  display: flex;
  flex-direction: column;
  padding: 4px 0;
  gap: 4px;
`;

export const PlanFormLabel = styled.label`
  font-weight: ${(props) => props.theme.fontWeight.bold};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 3px;

  svg {
    transform: translateY(2px);
  }
`;

const DowngradeTooltip = styled.div`
  width: 100%;
  display: flex;
`;

export const downgradeTooltipClass = DowngradeTooltip.styledComponentId as string;
